<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="copyright ">
        כל הזכויות שמורות לעורך דין סלבה שצקי © אין באמור באתר זה משום מתן ייעוץ
        משפטי &copy; {{ year }}
        <br />
        made with <md-icon>favorite</md-icon> by
        <a href="http://www.elzam.net/" target="_blank">Elad Elzam</a>.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
